import { Paper } from '@mui/material';
import { Layout, theme } from 'antd';
import MainHeader from './main-header';
import Sidebar from './sidebar';
import classes from './user-main-layout.module.css';
const { Header, Content, Sider } = Layout;

function UserMainLayout({ children, type }) {
   const {
      token: { colorBgContainer },
   } = theme.useToken();
   return (
      <>
         <Layout style={{ minHeight: '100vh', background: '#F9FAFC' }}>
            <Header className={classes.header}>
               <MainHeader type={type} />
            </Header>

            <Layout className={classes.main} style={{ background: '#F9FAFC' }}>
               <Sider theme="light" className={classes.sidebar}>
                  <Sidebar type={type} />
               </Sider>
               <Paper elevation={1} style={{ width: '100vw' }} className={classes.container}>
                  <Content>{children}</Content>
               </Paper>
            </Layout>
         </Layout>
      </>
   );
}

export default UserMainLayout;
